import React, {useMemo} from 'react';
import {IChecklistModel} from '@src/@interfaces/models/Checklist/IChecklistModel';
import Checklist, {Props} from './Checklist';
import classnames from '@src/helpers/classnames';
import RenderIf from '@src/components/RenderIf/RenderIf';
import NoRecordsFound from '@src/components/NoRecordsFound/NoRecordsFound';
import {filterChecklists} from '@views/orders/ChecklistFilter';

export default function ListOfChecklist(props: {
    productId?: number | string,
    checklists: IChecklistModel[],
    size?: 'sm' | 'lg' | null,
    displayOnlyWithType?: IChecklistModel['type'],
    currentStatusId: number | string,
} & Omit<Props, 'items'>) {
    const {checklists, size, displayOnlyWithType, currentStatusId, ...rest} = props;
    const {productId} = props;

    const list = useMemo(() => {
        return filterChecklists(currentStatusId, checklists, productId, displayOnlyWithType);
    }, [checklists, currentStatusId, displayOnlyWithType, productId]);

    return <div className="row">
        <RenderIf expression={!list.length}>
            <NoRecordsFound/>
        </RenderIf>

        {list.map(item => {
            return <div key={item.id} className="col-auto">
                <div className="px-2 py-1 border rounded-2">
                    <label className={classnames('form-label', {[`form-label-${size}`]: size})}>
                        {item.title}
                    </label>

                    <Checklist items={item.items as any} {...rest}/>
                </div>
            </div>;
        })}
    </div>;
}
